import useSend from './useSend';

function usePut<T, Req = T>(
   path: string,
): [(body: Req) => Promise<T>, T | null, Error | null] {
   return useSend<T, Req>('put', path);
}

export default usePut;
